(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.cmp-dropdown-nav__details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cmp-dropdown-nav__details[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
